const removeAuth = () => {
  localStorage.removeItem('memberData')
  localStorage.removeItem('memberAccessToken');
  localStorage.removeItem('isOnboarding');
  localStorage.removeItem('profileComplete');
}
const removeAdminAuth = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem('accessToken');
  localStorage.removeItem('usertype');

}
export { removeAuth, removeAdminAuth }